export default ".txt-bold {\n  font-weight: bold;\n}\n\n.txt-big {\n  font-size: 1.3em;\n}\n\n.txt-blue {\n  color: #2a1b55;\n}";